import ABCSelectCustomModule from 'src/modules/abcSelectCustom/module';
import AgentDocsModule from 'src/modules/agentDocs/module';
import AgentDocsSlice from 'src/modules/agentDocs/slice';
import PolicyDetailsModule from 'src/modules/policyDetails/module';
import policyDetailsSlice from 'src/modules/policyDetails/slice';

export const moduleList = {
  ...AgentDocsModule,
  ...PolicyDetailsModule,
  ...ABCSelectCustomModule,
};

export const reducerList = {
  ...AgentDocsSlice,
  ...policyDetailsSlice,
};
